// Do not edit.
import { ShaderStore } from "core/Engines/shaderStore";
import "../Shaders/ShadersInclude/atmosphereFragmentDeclaration";
import "../Shaders/ShadersInclude/atmosphereUboDeclaration";
import "core/Shaders/ShadersInclude/helperFunctions";
import "../Shaders/ShadersInclude/atmosphereFunctions";

const name = "skyViewPixelShader";
const shader = `#define RENDER_SKY_VIEW 1
precision highp float;precision highp sampler2D;
#include<__decl__atmosphereFragment>
#include<helperFunctions>
#include<atmosphereFunctions>
varying vec2 uv;uniform sampler2D transmittanceLut;uniform sampler2D multiScatteringLut;void main() {gl_FragColor=renderSkyView(uv,transmittanceLut,multiScatteringLut);}`;
// Sideeffect
if (!ShaderStore.ShadersStore[name]) {
    ShaderStore.ShadersStore[name] = shader;
}
/** @internal */
export const skyViewPixelShader = { name, shader };
